import { render, staticRenderFns } from "./expired-page.vue?vue&type=template&id=427667ed&scoped=true"
import script from "./expired-page.vue?vue&type=script&lang=js"
export * from "./expired-page.vue?vue&type=script&lang=js"
import style0 from "./expired-page.vue?vue&type=style&index=0&id=427667ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427667ed",
  null
  
)

export default component.exports